import { Directive, ElementRef, Input, OnChanges, OnDestroy, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appWaitForImage]',
  standalone: false
})
export class WaitForImageDirective implements OnChanges, OnDestroy {
  @Input('appWaitForImage') url: string;
  @Input() backgroundImage: boolean;
  @Input() showSpinner: boolean;
  @Input() maxRetries = 3;
  @Input() delay = 500;

  retry = 0;
  timer: NodeJS.Timer;
  latestRetriedUrl: string;
  suffix: string;
  image: HTMLImageElement;

  constructor(
    private elRef: ElementRef<HTMLImageElement>,
    private renderer: Renderer2
  ) {
    'ngInject';

    this.init();
  }

  ngOnChanges(changes: SimpleChanges) {
    const url = changes.url && changes.url.currentValue;

    if (url) {
      this.url = url;
      this.retry = 0;
      this.suffix = (this.url.indexOf('?') > -1 ? '&' : '?') + 't=';
      this.image.src = this.latestRetriedUrl = this.url;
      this.setImage(this.url);
    } else {
      clearTimeout(this.timer);
      this.renderer.removeClass(this.elRef.nativeElement, 'wait-for-image_in-progress');
      this.clearImage();
    }
  }

  ngOnDestroy(): void {
    clearTimeout(this.timer);
  }

  private init() {
    this.image = new Image();
    this.image.onload = () => this.setImage(this.latestRetriedUrl);
    this.image.onerror = () => {
      if (this.showSpinner) {
        this.renderer.addClass(this.elRef.nativeElement, 'wait-for-image_in-progress');
      }

      this.timer = setTimeout(
        () => {
          if (this.retry < parseInt(this.maxRetries.toString(), 10)) {
            this.retry++;
            this.image.src = this.latestRetriedUrl = this.url + this.suffix + Date.now();
          }
        },
        parseInt(this.delay.toString(), 10)
      );
    };
  }

  private setImage(url: string): void {
    if (this.showSpinner) {
      this.renderer.removeClass(this.elRef.nativeElement, 'wait-for-image_in-progress');
    }

    if (this.backgroundImage) {
      this.renderer.setStyle(this.elRef.nativeElement, 'backgroundImage', `url(${url})`);
    } else {
      this.renderer.setAttribute(this.elRef.nativeElement, 'src', url);
    }
  }

  private clearImage() {
    if (this.backgroundImage) {
      this.renderer.setStyle(this.elRef.nativeElement, 'backgroundImage', 'none');
    } else {
      this.renderer.setAttribute(this.elRef.nativeElement, 'src', '');
    }
  }
}
